import { publicPath } from 'signals/publicPath';

const Notfound = () => {
  const PUBLIC_PATH = publicPath.value;

  return (
    <div className="pk-container">
      <div className="pk-col pk-col--span-12">
        <h1>Error 404</h1>
        <p>That page doesn&apos;t exist.</p>
        <a href={`${PUBLIC_PATH}competitions`}>
          <h4>Back to Home</h4>
        </a>
      </div>
    </div>
  );
};

export default Notfound;
